import { render, staticRenderFns } from "./producttzbs.vue?vue&type=template&id=255ad4b0&scoped=true&"
import script from "./producttzbs.vue?vue&type=script&lang=js&"
export * from "./producttzbs.vue?vue&type=script&lang=js&"
import style0 from "./producttzbs.vue?vue&type=style&index=0&id=255ad4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ad4b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255ad4b0')) {
      api.createRecord('255ad4b0', component.options)
    } else {
      api.reload('255ad4b0', component.options)
    }
    module.hot.accept("./producttzbs.vue?vue&type=template&id=255ad4b0&scoped=true&", function () {
      api.rerender('255ad4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/physical/producttzbs.vue"
export default component.exports